module.exports = __webpack_public_path__ + "img/rob.4acfdf04.jpeg";